import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-filter-transactions',
  templateUrl: './filter-transactions.component.html',
  styleUrls: ['./filter-transactions.component.scss']
})
export class FilterTransactionsComponent implements OnInit {

  @Input() filterableObjects: any[] = [];
  @Output() filteredObjects = new EventEmitter<any[]>();
  @Output() updatedPageSize = new EventEmitter<number>();

  pageSize = 10;

  constructor() { }

  ngOnInit(): void {
    this.filteredObjects.emit([...this.filterableObjects]);
  }

  ngOnChanges(): void {
    this.filteredObjects.emit([...this.filterableObjects]);
  }

  processFilteredText(filterText: string): void {
    if (filterText === '') {
      this.filteredObjects.emit([...this.filterableObjects]);
    }
    else {
      const filteredObjects: any[] = [];

      this.filterableObjects.forEach((val, idx) => {
        if (val.company.toLowerCase().includes(filterText.toLowerCase())) {
          filteredObjects.push(val);
        }
        else if (val.product_name.toLowerCase().includes(filterText.toLowerCase())) {
          filteredObjects.push(val);
        }

      });

      this.filteredObjects.emit([...filteredObjects]);
    }
  }

  updatePageEntries(pageSize): void {
    this.updatedPageSize.emit(pageSize);
  }


}
